/**
 * Erro de renderização vira mensagem, não tela branca.
 *
 * Sem isto, qualquer exceção durante a renderização desmonta a árvore inteira
 * do React e a pessoa fica olhando para o fundo vazio, sem saber se é o sinal,
 * o aparelho ou o sistema. A mensagem técnica aparece junto para quem for
 * relatar o problema.
 */

import { Component, type ReactNode } from 'react';

export default class Falha extends Component<{ children: ReactNode }, { erro: Error | null }> {
  override state = { erro: null as Error | null };

  static getDerivedStateFromError(erro: Error) {
    return { erro };
  }

  override componentDidCatch(erro: Error) {
    console.error(erro);
  }

  override render() {
    const { erro } = this.state;
    if (!erro) return this.props.children;

    return (
      <div className="mx-auto flex min-h-dvh max-w-md flex-col justify-center gap-3 bg-[var(--bg)] p-6 text-[15px] text-[var(--fg)]">
        <p className="font-semibold">Algo deu errado nesta tela.</p>
        <p className="text-[var(--muted)]">
          Tente recarregar. Se continuar, envie esta mensagem ao suporte:
        </p>
        <pre className="whitespace-pre-wrap break-words rounded-[var(--r-md)] bg-[var(--bg-subtle)] p-3 text-xs">
          {erro.message}
          {'\n\n'}
          {navigator.userAgent}
        </pre>
        <button
          onClick={() => location.reload()}
          className="anel-foco h-11 rounded-[var(--r-md)] border border-[var(--border)] font-medium"
        >
          Recarregar
        </button>
      </div>
    );
  }
}
